/**
 * 直播 接口的统一出口
 */
import axios from '../http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

const api = '/c-api/'

const index = {
  // 直播列表
  livingList (params) {
    return axios.get('/home/liveroom/list', { params: params })
  },
  // 匠人直播详情
  myRoom (params) {
    return axios.get('/home/liveroom/myroom', { params: params })
  },
  // 直播类型--匠人
  typeList (params) {
    return axios.get('/home/liveroom/typelist', { params: params })
  },
  // 申请直播--匠人
  applyLiving (params) {
    return axios.post('/home/liveroom/apply', qs.stringify(params))
  },
  // 是否存在待审核/或未过期的直播 --匠人
  livingReview (params) {
    return axios.get('/home/liveroom/roomreview', { params: params })
  },
  // 用户进入直播间
  livingDetail (params) {
    return axios.get('/home/liveroom/living', { params: params })
  },
  // 用户进入直播间(未登录)
  livingNoUserDetail (params) {
    return axios.get('/home/liveroom/liveroom', { params: params })
  },
  // 7.首页
  liveroomIndex (params) {
    return axios.get('/home/liveroom/index', { params: params })
  },
  // 8.视频列表
  livevideoList (params) {
    return axios.get('/home/livevideo/list', { params: params })
  },
  // 9.视频详情
  livevideoDetail (params) {
    return axios.get('/home/livevideo/detail', { params: params })
  },
  // 10.章节详情
  livevideochapterDetail (params) {
    return axios.get('/home/livevideochapter/detail', { params: params })
  },
  // 11.直播回放列表
  posvideoList (params) {
    return axios.get('/home/liveroom/callbackList', { params: params })
  },
  // 12.回放详情
  posvideoDetail (params) {
	return axios.get('/home/liveroom/callbackinfo', { params: params })
  },
  // 创建视频购买订单
  createVideoOrder(params){
	return axios.post('/home/livevideo/create', qs.stringify(params))
  },
  // 支付视频订单
  payVideoOrder(params){
	return axios.post('/home/livevideo/topay', qs.stringify(params))
  },
  // 我的视频
  myVideo(params){
	return axios.get('/home/user/center/video', { params: params })
  },
  // 视频评论
  videoComment(params){
	return axios.post('/home/livevideo/comment', qs.stringify(params))
  },
  // 添加视频观看记录
  addVideoLog(params){
	return axios.post('/home/livevideo/watchlog', qs.stringify(params))
  },
  // 查看视频观看记录
  myVideoLog(params){
	return axios.get('/home/livevideo/watchlog', { params: params })
  }
}

// 导出接口
export default index
